import { Component, Input } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgLocalization } from '@angular/common';

import { Denuncia } from '../denuncia/denuncia';
import { DenunciaService } from '../denuncia/denuncia.service';
import { Incidente } from '../incidente/incidente';
import { IncidenteService } from '../incidente/incidente.service';
import { Entrevista } from '../entrevistas/entrevista';
import { EntrevistaService } from '../entrevistas/entrevista.service';


@Component({
  selector: 'app-modal-psic',
  template: `
  <div id="modalencpsic" (click)="onContainerClicked($event)" class="modal fade" tabindex="-1" [ngClass]="{'in': visibleAnimate}"
       [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal();">&times;</button>
        <h4 class="modal-title">Encaminhamento Psicológico</h4>
          <ng-content select=".app-modal-header"></ng-content>
        </div>
        <form id="login-form">
        <div class="modal-body">
            <p><label for="Nomes">Pessoas encaminhadas para o departamento psicológico:</label></p>
            <ul>
            <li *ngFor="let entrevista of entrevistas">
            {{entrevista.nome}}
            </li>
            </ul>
            <ng-content select=".app-modal-body"></ng-content>
        </div>
        <div class="modal-footer">
            <div class="col-sm-offset-2 col-sm-10">
            <button type="button" class="btn btn-default" (click)="closeModal();">Fechar</button>
            </div>
          <ng-content select=".app-modal-footer"></ng-content>
        </div>
        </form>
      </div>
    </div>
  </div>
  `,
  styles: [`
    .modal {
      background: rgba(0,0,0,0.6);
    }
  `],
  providers: [
    DenunciaService,
    IncidenteService,
    EntrevistaService
  ]
})
export class ModalNomesEncaminhamentoPsicologicoComponent {

  public visible = false;
  private visibleAnimate = false;

  denuncia: Denuncia;

  incidente: Incidente;

  entrevista: Entrevista;

  descricaoencam: string;

  nomeencam: string;

  entrevistas: Entrevista[];

  @Input() idInc: number;

  constructor(private denService: DenunciaService, private incidenteService: IncidenteService, private entrevistaService: EntrevistaService, private router: Router) {
    this.entrevista = new Entrevista();
  }

  public getNomesEntrevistaEncaminhados(id): void {
    //console.log("id incidente = " + id);
    if (id !== undefined) {
      this.entrevistaService.getNomesEntrevistaEncaminhados(id)
        .then((resposta) => {this.entrevistas = resposta;});
    }

  }

  public show(id): void {

    //console.log("id incidente " + id);

    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);

    this.idInc = id; // id do incidente

    this.getNomesEntrevistaEncaminhados(id);

  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public closeModal(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

  goBack(resposta: any): void {
     alert(resposta);
     window.location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/denuncias/modalnomesencaminhamentopsicologico.component.ts